export default __webpack_public_path__ + "static/ico-ludzie-f30cf06f9cea68821de2fa0b69cb95e3.svg";